import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ServicesSection } from './components/ServicesSection';
import { DifferentialsSection } from './components/DifferentialsSection';
import { StatsSection } from './components/StatsSection';
import { ProcessSection } from './components/ProcessSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-white font-body text-gray-900 selection:bg-accent selection:text-primary" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <DifferentialsSection data-id="element-5" />
        <StatsSection data-id="element-6" />
        <ProcessSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <ContactSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <FloatingWhatsApp data-id="element-12" />
    </div>;
}